import { useTheme } from '@mui/material';
import React, { createContext, useState, Dispatch, SetStateAction, ReactNode, useContext } from 'react';

export interface AppContextType {
  drawerExpanded: boolean;
  setDrawerExpanded: Dispatch<SetStateAction<boolean>>;
  transitioningMenu: boolean;
  setTransitioningMenu: Dispatch<SetStateAction<boolean>>;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const theme = useTheme();
  const [drawerExpanded, setDrawerExpanded] = useState<boolean>(window.innerWidth > theme.breakpoints.values.md);
  const [transitioningMenu, setTransitioningMenu] = useState<boolean>(false);
  return <AppContext.Provider value={{ drawerExpanded, setDrawerExpanded, transitioningMenu, setTransitioningMenu }}>{children}</AppContext.Provider>;
};

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
